import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_down",
  "use": "chevron_down-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"chevron_down\"><path d=\"M3 5c0-.3.1-.5.3-.7.4-.4 1-.4 1.4 0L6 5.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L6 8.4 3.3 5.7C3.1 5.5 3 5.3 3 5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol